import billingApiModule from '../billingApi.module';

class BillingRequestApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    submitRequest(subscriptionId, planId) {
        var body = {
            planId
        };

        if (subscriptionId) {
            body.subscriptionId = subscriptionId;
        }

        return this.apiUtil.postWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/requests`,
            body
        );
    }
}

export default billingApiModule.service(
    'billingRequestApiService',
    BillingRequestApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/request/billingRequestApi.service.js